function copyToClipboard(text: string) {
  if (!navigator.clipboard) {
    // Clipboard API를 지원하지 않는 경우
    const textarea = document.createElement("textarea");
    textarea.value = text;
    textarea.style.position = "fixed"; // 화면에서 안 보이게 고정
    textarea.style.opacity = "0";
    document.body.appendChild(textarea);
    textarea.focus();
    textarea.select();
    try {
      const successful = document.execCommand("copy");
      console.log(successful ? "복사 성공!" : "복사 실패!");
    } catch (err) {
      console.error("복사 중 오류가 발생했습니다:", err);
    }
    document.body.removeChild(textarea);
    return;
  }

  // Clipboard API를 사용하는 경우
  navigator.clipboard
    .writeText(text)
    .then(() => {
      console.log("링크 복사 성공:", text);
    })
    .catch((err) => {
      console.error("링크 복사 실패:", err);
    });
}

export default copyToClipboard;
